import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import {
  PermissionManagement,
} from "../../modules/permission-management";
import TenantContextBanner from "../../components/common/TenantContextBanner";
import useAuth from "../../hooks/useAuth";

const PermissionsPage = () => {
  const { isTenantUser, isSystemUser, activeTenantId } = useAuth();
  const location = useLocation();
  const isTenantScope =
    isTenantUser || location.pathname.startsWith("/tenant-");

  // System Permissions API is not available yet — keep tenant permissions only.
  if (isSystemUser && !isTenantScope) {
    return <Navigate to="/dashboard" replace />;
  }

  if (isSystemUser && isTenantScope && !activeTenantId) {
    return <Navigate to="/tenantmgmt" replace />;
  }

  return (
    <>
      {isTenantScope && !isTenantUser ? <TenantContextBanner /> : null}
      <PermissionManagement />
    </>
  );
};

export default PermissionsPage;
